// quiz.js
const THINKING_CHECK_ICON_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M9 18C10.1819 18 11.3522 17.7672 12.4442 17.3149C13.5361 16.8626 14.5282 16.1997 15.364 15.364C16.1997 14.5282 16.8626 13.5361 17.3149 12.4442C17.7672 11.3522 18 10.1819 18 9C18 7.8181 17.7672 6.64778 17.3149 5.55585C16.8626 4.46392 16.1997 3.47177 15.364 2.63604C14.5282 1.80031 13.5361 1.13738 12.4442 0.685084C11.3522 0.232792 10.1819 -1.76116e-08 9 0C6.61305 3.55683e-08 4.32387 0.948211 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM8.768 12.64L13.768 6.64L12.232 5.36L7.932 10.519L5.707 8.293L4.293 9.707L7.293 12.707L8.067 13.481L8.768 12.64Z"
      fill="#02B974"/>
  </svg>
`;

// 1. Define all steps (11 total)
const steps = [
  // 1–8: questions
  {
    id: "q1",
    type: "question",
    text: "Do you have a family history of heart problems?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "not_sure", label: "Not sure" },
    ],
  },
  {
    id: "q2",
    type: "question",
    text: "Do you often feel tired or fatigued?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  {
    id: "q3",
    type: "question",
    text: "Do you ever get short of breath after mild activity?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  {
    id: "q4",
    type: "question",
    text: "Do you often have cold hands or feet?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  {
    id: "q5",
    type: "question",
    text: "Do you experience brain fog or memory problems?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  {
    id: "q6",
    type: "question",
    text: "Are you currently on any heart medications?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  {
    id: "q7",
    type: "question",
    text: "Do you have high cholesterol?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "not_sure", label: "Not sure" },
    ],
  },
  {
    id: "q8",
    type: "question",
    text: "Do you have high blood pressure?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "not_sure", label: "Not sure" },
    ],
  },
  // 9: goal selection step
  {
    id: "goal",
    type: "goal",
    text: "What is your most important health goal?",
    options: [
      {
        value: "lower_cholesterol",
        label: "Lower cholesterol",
        image:
          "https://cdn.shopify.com/s/files/1/0059/6331/7363/files/9ba0f8c9fc80f3ae29c29746c617e99722384b58.png?v=1763150898",
      },
      {
        value: "lower_bp",
        label: "Lower blood pressure",
        image:
          "https://cdn.shopify.com/s/files/1/0059/6331/7363/files/00faa3da6c188092d3f58163d77536819bd2fa91.png?v=1763151128",
      },
      {
        value: "off_meds",
        label: "Get off medications",
        image:
          "https://cdn.shopify.com/s/files/1/0059/6331/7363/files/64fb673ae535aea783d13e2df2694fe1ee3827fe.png?v=1763151182",
      },
      {
        value: "prevent_attack",
        label: "Prevent heart attack risk",
        image:
          "https://cdn.shopify.com/s/files/1/0059/6331/7363/files/aeef30181a7ceac449141cde24fe6fbc0685c28b.png?v=1763151301",
      },
      {
        value: "all_of_the_above",
        label: "All of the above",
        image: null, // rendered as separate button
      },
    ],
  },

  // 10: thinking
  {
    id: "thinking",
    type: "thinking",
  },

  // 11: final result
  {
    id: "result",
    type: "result",
  },
];

// 2. Global state
const state = {
  currentIndex: 0,
  answers: {}, // { stepId: value }
};

const app = document.getElementById("app");
let thinkingTimer = null;

// 3. Helper: save answer + auto-advance
function handleAnswerAndAdvance(stepId, value) {
  state.answers[stepId] = value;

  // tiny delay so "selected" visual is visible
  setTimeout(() => {
    const isLastStep = state.currentIndex >= steps.length - 1;
    if (!isLastStep) {
      goToStep(state.currentIndex + 1, "forward");
    }
  }, 220);
}

// 4. Render the current step
function renderStep(direction = "in-place") {
  const step = steps[state.currentIndex];
  const percent = ((state.currentIndex + 1) / steps.length) * 100;
  const isResultPage = step.id === "result";
  const animateClass =
    direction === "forward" || direction === "backward" ? " animate-in" : "";

  // 1. Base layout: header + empty card
  app.innerHTML = `
    <div class="quiz-page">
      <div class="quiz-header">
        <button class="header-back"${
          state.currentIndex === 0 ? " disabled" : ""
        }>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none">
  <path d="M6.20676 0.292786C6.01923 0.105315 5.76492 0 5.49976 0C5.23459 0 4.98028 0.105315 4.79276 0.292786L0.292756 4.79279C0.105285 4.98031 -3.05176e-05 5.23462 -3.05176e-05 5.49979C-3.05176e-05 5.76495 0.105285 6.01926 0.292756 6.20679L4.79276 10.7068C4.98136 10.8889 5.23396 10.9897 5.49616 10.9875C5.75835 10.9852 6.00917 10.88 6.19457 10.6946C6.37998 10.5092 6.48515 10.2584 6.48743 9.99619C6.48971 9.73399 6.38891 9.48139 6.20676 9.29279L3.49976 6.49979H12.9998C13.265 6.49979 13.5193 6.39443 13.7069 6.20689C13.8944 6.01936 13.9998 5.765 13.9998 5.49979C13.9998 5.23457 13.8944 4.98022 13.7069 4.79268C13.5193 4.60514 13.265 4.49979 12.9998 4.49979H3.49976L6.20676 1.70679C6.39423 1.51926 6.49954 1.26495 6.49954 0.999786C6.49954 0.734622 6.39423 0.480314 6.20676 0.292786Z" fill="white"/>
</svg>
        </button>
        <img
          class="header-logo"
          src="https://cdn.shopify.com/s/files/1/0059/6331/7363/files/1b596358e4e5cd408779c02dab35ef862fddfec5.png?v=1763149417"
          alt="Luma Nutrition"
        />
        <div class="header-progress-wrapper">
          <div
            class="header-progress-bar"
            style="width: ${percent}%;"
          ></div>
        </div>
      </div>

      <div class="quiz-card${animateClass} ${
    isResultPage ? "final-step" : ""
  }"></div>
    </div>
  `;

  const page = app.querySelector(".quiz-page");
  const card = page.querySelector(".quiz-card");
  const backBtn = page.querySelector(".header-back");

  // Back button behavior
  backBtn.addEventListener("click", () => {
    if (state.currentIndex > 0) {
      goToStep(state.currentIndex - 1, "backward");
    }
  });

  // === STEP TYPES ===

  // 2. Question steps
  if (step.type === "question") {
    const optionsHtml = step.options
      .map((opt) => {
        const isSelected = state.answers[step.id] === opt.value;
        return `
          <button
            class="quiz-btn${isSelected ? " selected" : ""}"
            data-value="${opt.value}"
          >
            ${opt.label}
          </button>
        `;
      })
      .join("");

    card.innerHTML = `
      <div class="quiz-title">${step.text}</div>
      <div class="quiz-options">
        ${optionsHtml}
      </div>
    `;

    const buttons = card.querySelectorAll(".quiz-btn");
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const value = btn.dataset.value;
        buttons.forEach((b) => b.classList.remove("selected"));
        btn.classList.add("selected");
        handleAnswerAndAdvance(step.id, value);
      });
    });
  }

  // 3. Goal step (image cards + "All of the above" + Continue)
  if (step.type === "goal") {
    const regularOptions = step.options.slice(0, 4);
    const allOption = step.options[4];

    const cardsHtml = regularOptions
      .map((opt) => {
        const isSelected = state.answers[step.id] === opt.value;
        return `
          <div
            class="goal-card${isSelected ? " selected" : ""}"
            data-value="${opt.value}"
          >
            ${opt.image ? `<img src="${opt.image}" alt="${opt.label}" />` : ""}
            <div class="goal-card-label">${opt.label}</div>
          </div>
        `;
      })
      .join("");

    const allSelected = state.answers[step.id] === allOption.value;

    card.innerHTML = `
      <div class="quiz-title">${step.text}</div>
      <div class="goal-grid">
        ${cardsHtml}
      </div>
      <button
        class="goal-all-btn${allSelected ? " selected" : ""}"
        data-value="${allOption.value}"
      >
        ${allOption.label}
      </button>
      <button class="goal-continue-btn">
        CONTINUE
      </button>
    `;

    const grid = card.querySelector(".goal-grid");
    const allBtn = card.querySelector(".goal-all-btn");
    const continueBtn = card.querySelector(".goal-continue-btn");

    // Selección de tarjetas individuales
    grid.querySelectorAll(".goal-card").forEach((cardEl) => {
      cardEl.addEventListener("click", () => {
        const value = cardEl.dataset.value;
        // guardar respuesta
        state.answers[step.id] = value;

        // estado visual
        grid
          .querySelectorAll(".goal-card")
          .forEach((c) => c.classList.remove("selected"));
        allBtn.classList.remove("selected");
        cardEl.classList.add("selected");
      });
    });

    // Selección "All of the above"
    allBtn.addEventListener("click", () => {
      const value = allBtn.dataset.value;
      state.answers[step.id] = value;

      grid
        .querySelectorAll(".goal-card")
        .forEach((c) => c.classList.remove("selected"));
      allBtn.classList.add("selected");
    });

    // Botón Continue → siguiente paso
    continueBtn.addEventListener("click", () => {
      // si quieres obligar a seleccionar algo antes:
      // if (!state.answers[step.id]) return;
      goToStep(state.currentIndex + 1, "forward");
    });
  }

  // 4. Thinking step
  if (step.type === "thinking") {
    renderThinkingCard(card);
  }

  //5. Result step
  if (step.type === "result") {
    renderResultCard(card);
  }

  // 6. Start thinking animation if needed
  if (step.type === "thinking") {
    startThinkingSequence(card);
  }
}

// 5. Thinking step rendering
function renderThinkingCard(card) {
  const texts = [
    "Evaluating your answers…",
    "Analyzing results…",
    "Determining heart profile…",
    "Building summary…",
  ];

  const itemsHtml = texts
    .map(
      (t) => `
      <li class="thinking-item">
        <div class="thinking-icon">
          ${THINKING_CHECK_ICON_SVG}
        </div>
        <span>${t}</span>
      </li>`
    )
    .join("");

  card.innerHTML = `
    <div class="thinking-header">Determining Your Heart Profile</div>
    <div class="spinner"></div>
    <ul class="thinking-list">
      ${itemsHtml}
    </ul>
  `;
}

function startThinkingSequence(card) {
  const items = card.querySelectorAll(".thinking-item");
  items.forEach((item, idx) => {
    setTimeout(() => {
      item.classList.add("done");
    }, (idx + 1) * 600);
  });

  thinkingTimer = setTimeout(() => {
    if (steps[state.currentIndex].type === "thinking") {
      goToStep(state.currentIndex + 1, "forward");
    }
  }, items.length * 600 + 800);
}

// 6. Result step rendering (STATIC RESULT)
function renderResultCard(card) {
  // Always the same result, regardless of answers
  const level = "High";
  const thumbPosition = 85; // posición final en la barra (%)
  const description =
    "Your answers indicate several signs commonly associated with elevated heart-health risk.";

  const labels = ["Low", "Normal", "Medium", "High"];
  const labelsHtml = labels.map((label) => `<span>${label}</span>`).join("");

  card.innerHTML = `
    <div class="quiz-title">Summary Of Your Heart Profile</div>

    

    <div class="result-body">
    <div class="result-header">
      <div class="result-title">Heart health risk</div>
      <div class="result-badge">${level}</div>
    </div>
      <img
        class="result-photo"
        src="https://cdn.shopify.com/s/files/1/0059/6331/7363/files/a02936b9af8f12efc19d827571c8ddb1d614e50e.png?v=1763151815"
        alt="Heart health profile"
      />

      <div class="result-scale">
        <div class="result-scale-bar">
          <div
            class="result-scale-thumb"
            data-target-left="${thumbPosition}"
          >
          <span class="tooltiptext">Your level</span>
          </div>
        </div>
        <div class="result-scale-labels">
          ${labelsHtml}
        </div>
      </div>
      <div class="result-wrapper">
         <div class="result-text-icon">
         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 4.817e-07 10 0C4.49 -4.81702e-07 4.81702e-07 4.49 0 10C-4.817e-07 15.51 4.49 20 10 20ZM10.75 14C10.75 14.41 10.41 14.75 10 14.75C9.59 14.75 9.25 14.41 9.25 14V9C9.25 8.59 9.59 8.25 10 8.25C10.41 8.25 10.75 8.59 10.75 9V14ZM9.08 5.62C9.13 5.49 9.2 5.39 9.29 5.29C9.39 5.2 9.5 5.13 9.62 5.08C9.74 5.03 9.87 5 10 5C10.13 5 10.26 5.03 10.38 5.08C10.5 5.13 10.61 5.2 10.71 5.29C10.8 5.39 10.87 5.49 10.92 5.62C10.97 5.74 11 5.87 11 6C11 6.13 10.97 6.26 10.92 6.38C10.87 6.5 10.8 6.61 10.71 6.71C10.61 6.8 10.5 6.87 10.38 6.92C10.14 7.02 9.86 7.02 9.62 6.92C9.5 6.87 9.39 6.8 9.29 6.71C9.2 6.61 9.13 6.5 9.08 6.38C9.03 6.26 9 6.13 9 6C9 5.87 9.03 5.74 9.08 5.62Z" fill="#F04D4D"/>
</svg>
         </div>
          <div class="result-text-title">HIGH level</div>
          <div class="result-text-body">
            ${description}
          </div>
      </div>
    </div>

    <button class="result-cta">
      Get your heart health in control
    </button>
  `;

  // CTA
  const cta = card.querySelector(".result-cta");
  if (cta) {
    cta.addEventListener("click", () => {
      window.location.href = "https://lumanutrition.com/products/heart-health";
    });
  }

  // Animación del thumb de 0% -> 85%
  const thumb = card.querySelector(".result-scale-thumb");
  if (thumb) {
    const target = thumb.dataset.targetLeft || "85";

    // empezamos en 0
    thumb.style.left = "0%";

    // siguiente frame: mover al objetivo para disparar la transición
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        thumb.style.left = `${target}%`;
      });
    });
  }
}

// 7. Step transition helper (animations)
function goToStep(targetIndex, direction) {
  if (targetIndex < 0 || targetIndex >= steps.length) return;

  if (thinkingTimer) {
    clearTimeout(thinkingTimer);
    thinkingTimer = null;
  }

  const oldCard = app.querySelector(".quiz-card");
  if (!oldCard) {
    state.currentIndex = targetIndex;
    renderStep(direction);
    return;
  }

  const outClass =
    direction === "backward" ? "animate-out-backward" : "animate-out-forward";

  oldCard.classList.remove("animate-in");
  oldCard.classList.add(outClass);

  oldCard.addEventListener(
    "animationend",
    () => {
      state.currentIndex = targetIndex;
      renderStep(direction);
    },
    { once: true }
  );
}

// 8. Initial render
renderStep();
